import type { QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';
import type { Query } from '@/types/GraphqlSchema';

type DevelopmentTypeQueryData = Pick<Query, 'developmentType'>;
type DevelopmentTypeQueryVariables = Record<string, never>;

const DEVELOPMENT_TYPE_QUERY: TypedDocumentNode<
  DevelopmentTypeQueryData,
  DevelopmentTypeQueryVariables
> = gql`
  query developmentType {
    developmentType {
      id
      name
    }
  }
`;

type DevelopmentTypeQueryOptions = QueryHookOptions<
  DevelopmentTypeQueryData,
  DevelopmentTypeQueryVariables
>;

export const useDevelopmentType = (options?: DevelopmentTypeQueryOptions) => {
  const queryOptions: DevelopmentTypeQueryOptions = {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    ...(options ?? {}),
  };

  const { data, loading, error, refetch } = useQuery(DEVELOPMENT_TYPE_QUERY, queryOptions);

  return {
    data,
    loading,
    error,
    refetch,
    developmentTypes: data?.developmentType ?? [],
  };
};
